import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class ObjectivesAdd extends Component{
	render(){
		const {objectives} =this.props;
		let oc = _.find(objectives.permissions, (o) => {return o==='Create'});
		return (
			oc ?
				<p>
					<NavLink to={`/proigualdad/objetivos/crear`} className="button is-small is-inm-purple">{'Agregar objetivo'}</NavLink>
				</p>:''
		)
	}
}

export default SecureLayout(ObjectivesAdd);


// WEBPACK FOOTER //
// ./src/elements/objectives/widget/objectives_add.jsx